import {Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {MatSnackBar} from '@angular/material/snack-bar';
import {filter, interval} from 'rxjs';
import {clearIndexKeysFromCache, unregisterServiceWorker} from '@shared/util/cache-util';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerUpdateService {

  constructor(private _swUpdate: SwUpdate, private snackbar: MatSnackBar) {

    this._swUpdate.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`, evt.version);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`,  evt.currentVersion);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`, evt.latestVersion);
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`, evt.version);
          break;
        case 'NO_NEW_VERSION_DETECTED':
          console.log(`No new app version detected.`, evt.version);
          break;
      }
    });

    this._swUpdate.unrecoverable.subscribe((evt) => {
      console.error(`An error occurred during service worker update: ${evt.reason}`, evt);
    });

    this._swUpdate.versionUpdates.pipe(
      filter(versionEvent => versionEvent.type === 'VERSION_READY')
    ).subscribe(() => {
      clearIndexKeysFromCache();
      unregisterServiceWorker();
      const snack = this.snackbar.open('Mise à jour disponible', 'Mettre à jour');
      snack.onAction().subscribe(() => {
        document.location.reload();
      });
    });
    if (_swUpdate.isEnabled) {
      interval(2 * 60 * 60 * 1000)
        .subscribe(() => _swUpdate.checkForUpdate());
    }
  }
}
